import * as React from "react";
function SvgFrameChart(
  props: React.SVGProps<SVGSVGElement>,
  svgRef?: React.Ref<SVGSVGElement>
) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      stroke="currentColor"
      fill="none"
      strokeWidth={2}
      ref={svgRef}
      {...props}
    >
      <rect width={20} height={20} x={6} y={6} rx={2} />
      <path d="M12 14v8m4-11v11m4-7v7" />
    </svg>
  );
}
const ForwardRef = React.forwardRef(SvgFrameChart);
const MemoForwardRef = React.memo(ForwardRef);
export default MemoForwardRef;
